export default "__VITE_ASSET__CLCtCdCg__"